import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import Utils from '@app/shared/utils';
import { FieldUpdate } from '@app/shared/_models/field-update';
import { Sync } from '@app/shared/_models/sync';
import { environment } from '@environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConceptsService {
  private modelName = "concept";
  public conceptSubject: BehaviorSubject<any>;
  public concept: Observable<any>;
  
  constructor(
    public router: Router,
    public http: HttpClient
  ) {
    this.conceptSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem(this.modelName+'Records')));
    this.concept = this.conceptSubject.asObservable();
   }
  
   public get recordsValue() {
    return this.conceptSubject.value;
  }
  public get recordsObservable() {
    return this.concept;
  }

  getAll(){
    return this.http.get(`${environment.apiUrl}/dashboard/models/getAll/${this.modelName}`)
    .pipe(
      map(res => {
        localStorage.setItem(this.modelName+'Records', JSON.stringify(res));
        this.conceptSubject.next(res);
        return res;
      })
    );
  }

  getById(id: string){
    return this.http.get(`${environment.apiUrl}/dashboard/models/get/concept/${id}`)
  }

  add(item: any){
    var guid = Utils.generateGuid()
    var sync = Utils.convertToSync(item, this.modelName, guid);
    return this.http.post<Sync>(`${environment.apiUrl}/sync/push`, sync)
    .pipe(
      mergeMap(res => {
        return this.getById(res['insertedModelIds'][this.modelName][guid]['assignedId'])
        .pipe(
          map(newItem => {
            var records = this.conceptSubject.value;
            records['results'].splice(0,0,newItem);
            localStorage.setItem(this.modelName+'Records', JSON.stringify(records));
            this.conceptSubject.next(records);
            return res;
          })
        );
      })
    );
  }

  update(item: any, modelId: string, versionId: string) {
    var original = this.conceptSubject.value['results'].find(x => x.modelId === modelId);
    item["meta"] = original["dataModel"]["meta"];
    var sync = Utils.getDiff(Utils.convertToSync(original['dataModel'], this.modelName, original['modelId'], original['versionId']), 
                              Utils.convertToSync(item, this.modelName, modelId, versionId));
    return this.http.post<Sync>(`${environment.apiUrl}/sync/push`, sync)
    .pipe(
      map(res => {
        var records = this.conceptSubject.value;
        var idx = records["results"].findIndex(x => x.modelId === modelId);
        records["results"][idx].dataModel = item;
        records["results"][idx].versionId = res['updatedModelVersionIds'][this.modelName][modelId];
        localStorage.setItem(this.modelName+'Records', JSON.stringify(records));
        this.conceptSubject.next(records);
        return res;
      })
    );
  }

  delete(id){
    var model = this.conceptSubject.value['results'].find(x => x.modelId === id)
    let sync = new Sync();
    let field = new FieldUpdate();
    field.fieldPath = "meta.voided";
    field.value = true;
    field.modelName = this.modelName;
    field.modelId = id;
    field.dateUpdated = new Date();
    field.dateSynced = null;
    field.userId = JSON.parse(localStorage.getItem('user')).id;
    sync.fieldUpdates.push(field);
    let token = {};
    token[this.modelName] = {};
    token[this.modelName][id] = model.versionId;
    sync.syncTokens = token;
    return this.http.post<Sync>(`${environment.apiUrl}/sync/push`, sync)
    .pipe(
      map(res => {
        var records = this.conceptSubject.value;
        records['results'].splice(records['results'].findIndex(x => x.modelId === model.modelId),1);
        localStorage.setItem(this.modelName+'Records', JSON.stringify(records));
        this.conceptSubject.next(records);
        return res;
      })
    );
  }
}
